export default "__VITE_PUBLIC_ASSET__a975b0e0__"